const getParamFromUrl = (param: string): string => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const paramValue = urlParams.get(param);
  return paramValue || '';
};

export const replaceParam = (queryString: string, queryParam: string, newValue: string) => {
  const urlParams = new URLSearchParams(queryString);
  urlParams.set(queryParam, newValue);
  return urlParams.toString();
};

export default getParamFromUrl;
